import { schoolScope } from '@/lib/query/scope'

/**
 * School: one school's full record, from `GET /v1/schools/:id`. Read by
 * `SchoolProvider` and `useSchools` for the active school, and by super-admin
 * tools for the school they picked. `detailWithConfig` is the super-admin
 * manage-school modal's read of the same route with navigation menus, app
 * config and years included, a different response, so a different key. The
 * request sends the key's school as `x-school-id`.
 */
export const schoolDetailKeys = {
  all: (schoolId: string | null) => [...schoolScope(schoolId), 'school-detail'] as const,
  detail: (schoolId: string | null) => [...schoolDetailKeys.all(schoolId), 'detail'] as const,
  detailWithConfig: (schoolId: string | null) => [...schoolDetailKeys.all(schoolId), 'detail-with-config'] as const
}
